import 'apps/pathways/styles/start/components/results.scss';
import PropTypes from 'prop-types';
import React from 'react';
import HawtIcon from 'apps/pathways/icons/hawt.svg';
import PathwayIcon from 'apps/pathways/icons/pathway.svg';
import SearchSvg from 'apps/pathways/icons/search.svg';
import ResultSet from 'apps/pathways/start/components/result-set';
import CaretSvg from 'library/icons/caret.svg';
import InfoIcon from 'library/icons/info-icon.svg';
import Tooltip from 'library/components/tooltip';

class Results extends React.Component {
  state = {
    hawt: null,
    matches: null,
    search: null,
    limits: {
      hawt: 1,
      matches: 3,
      search: 4,
    }
  }

  incremenetMatches = () => {
    let nextValue = this.state.limits.matches;
    if (nextValue === 0) {
      nextValue = 3;
    }

    this.setState({
      limits: {
        hawt: 0,
        matches: nextValue + (4 - (nextValue % 4)),
        search: 4
      }
    });
  }

  restoreDefaultIncrement = () => {
    this.setState({
      limits: {
        hawt: 1,
        matches: 3
      }
    });
  }

  incrementHawt = () => {
    let nextValue = this.state.limits.hawt;
    if (nextValue === 0) {
      nextValue = 3;
    }

    this.setState({
      limits: {
        matches: 0,
        hawt: nextValue + (4 - (nextValue % 4)),
        search: 4
      }
    });
  }

  incremenetSearch = () => {
    let nextValue = this.state.limits.search;
    if (nextValue === 0) {
      nextValue = 3;
    }
    this.setState({
      limits: {
        matches: 0,
        hawt: 0,
        search: nextValue + (4 - (nextValue % 4))
      }
    });
  }

  whatIsLoading = (result_section, state) => {
    this.setState(() => {
      const nextState = {...nextState};
      nextState[`${result_section}`] = state;
      return nextState;
    }, this.updateLoading);
  }

  updateLoading = () => {
    const { hawt, matches, search } = this.state;
    this.props.result_loading(hawt == true && matches == true && !search);
  }

  renderBack = (value='') => {
    let shouldRender = false;
    for (const key in this.state.limits) {
      if (key !== value && this.state.limits[key] == 0) {
        shouldRender = true;
      }
    }

    return (
      shouldRender
        ? (
          <a className="pathways-start-results-section-back" aria-label="" href="javascript:void(0)" onClick={this.restoreDefaultIncrement}><CaretSvg /></a>
        )
        : null
    );
  }

  render() {
    const {
      limits
    } = this.state;
    const {
      preferences,
      title,
      buildPathway,
      liked,
      disliked,
      hideMatchScores,
      defaultHawtCareer,
      most_recent_completed_assessment,
      softSkillIndex
    } = this.props;

    return (
      <div className="pathways-start-results-sections">
        {
          limits.hawt > 0 && title === ''
            ? (
              <section>
                <h1>{this.renderBack('hawt')}<HawtIcon /> Hot Careers
                  {
                    hideMatchScores &&
                      <Tooltip
                        modal={
                          <p style={{ margin: 0, padding: '1em' }}>
                          You might want to take a closer look at these careers because they’re great opportunities! We’ve ordered them by their match for you
                          </p>
                        }
                        direction={'top'}
                      >
                        <div className='info-header-icon'>
                          <InfoIcon style={{ marginLeft: '0.2em', height: '1em'}}/>
                        </div>
                      </Tooltip>
                  }
                </h1>
                <ResultSet
                  softSkillIndex={softSkillIndex}
                  most_recent_completed_assessment={most_recent_completed_assessment}
                  whatIsLoading={this.whatIsLoading}
                  buildPathway={buildPathway}
                  preferences={preferences}
                  hawt
                  liked={liked}
                  disliked={disliked}
                  limit={limits.hawt}
                  showMore={this.incrementHawt}
                  section={'hawt'}
                  hideMatchScores={hideMatchScores}
                  defaultHawtCareer={defaultHawtCareer}
                />
              </section>
            )
            : null
        }
        {
          limits.matches > 0 && title === ''
            ? (
              <section>
                <h1>
                  {this.renderBack('matches')}
                  <PathwayIcon />
                  My matches
                  {
                    hideMatchScores &&
                    <Tooltip
                      modal={
                        <p style={{ margin: 0, padding: '1em' }}>
                        Check out careers below! We’ve ordered them by their match for you.
                        </p>
                      }
                      direction={'top'}
                    >
                      <div className='info-header-icon'>
                        <InfoIcon style={{ marginLeft: '0.2em', height: '1em'}}/>
                      </div>
                    </Tooltip>
                  }
                </h1>
                <ResultSet
                  softSkillIndex={softSkillIndex}
                  most_recent_completed_assessment={most_recent_completed_assessment}
                  whatIsLoading={this.whatIsLoading}
                  buildPathway={buildPathway}
                  liked={liked}
                  disliked={disliked}
                  preferences={preferences}
                  limit={limits.matches}
                  showMore={this.incremenetMatches}
                  section={'matches'}
                  hideMatchScores={hideMatchScores}
                />
              </section>
            )
            : null
        }
        {
          title !== ''
            ? (
              <section>
                <h1>{this.renderBack('matches')}<SearchSvg /> Search Results</h1>
                <ResultSet
                  softSkillIndex={softSkillIndex}
                  most_recent_completed_assessment={most_recent_completed_assessment}
                  whatIsLoading={this.whatIsLoading}
                  buildPathway={buildPathway}
                  liked={liked}
                  disliked={disliked}
                  preferences={preferences}
                  limit={limits.search}
                  showMore={this.incremenetSearch}
                  title={title}
                  section={'search'}
                  hideMatchScores={hideMatchScores}
                />
              </section>
            )
            : null
        }
      </div>
    );
  }
}

Results.propTypes = {
  softSkillIndex: PropTypes.number,
  data: PropTypes.object,
  preferences: PropTypes.object,
  title: PropTypes.title,
  buildPathway: PropTypes.func,
  liked: PropTypes.bool,
  disliked: PropTypes.bool,
  change: PropTypes.bool,
  result_loading: PropTypes.func,
  hideMatchScores: PropTypes.bool,
  defaultHawtCareer: PropTypes.any,
  most_recent_completed_assessment: PropTypes.number
};

export default Results;
